// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2T7cr","header":"PatientQuestionnaire_header__17UNx","info":"PatientQuestionnaire_info__lJfxK"};